import React from "react";
import Icon from "@/components/Icon";
import Reveal from "@/components/Reveal";
import { WHY_POINTS } from "@/data/site";

export default function WhyCloudBeaker() {
  return (
    <section className="bg-cbmist py-20 lg:py-24">
      <div className="container-cb grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
        <div className="max-w-md">
          <h2 className="font-display text-3xl font-extrabold text-cbink sm:text-4xl">Why Cloud Beaker</h2>
          <p className="eyebrow mt-4">A Different Kind of Cloud Partner</p>
          <p className="mt-5 text-[17px] leading-relaxed text-cbslate">
            We combine deep technical expertise, strategic guidance and a partner-first mindset to
            help organizations achieve more with the cloud — on their terms. No lock-in, no
            one-size-fits-all, no guesswork.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-x-8 gap-y-8 sm:grid-cols-2">
          {WHY_POINTS.map((p, i) => (
            <Reveal key={p.title} delay={i * 70}>
              <div className="flex gap-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white text-primary shadow-card">
                  <Icon name={p.icon} size={22} />
                </span>
                <div>
                  <h3 className="text-[15px] font-bold text-cbink">{p.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-cbslate">{p.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
